<template>
  <modal
    ref="addReport"
    :ok-disabled="loading"
    :ok-title="!$parent.id ? 'Pridať' : 'Upraviť'"
    :title="!$parent.id ? 'Pridať report' : 'Upraviť report'"
    cancel-title="Zrušiť"
    full-height
    name="add-consumer"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveReport"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" v-bar>
          <div>
            <b-form-group
              label-cols-sm="5"
              label="Obdobie (m/r)"
              label-for="period"
            >
              <single-date
                v-model="form.reportDate"
                v-validate="'required'"
                :format="measureTypeFormat"
                :class="{ 'is-invalid': errors.has('period') }"
                data-vv-as="Obdobie"
                name="period"
              />
              <b-form-invalid-feedback>
                {{ errors.first('period') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Množstvo (kWh)"
              label-for="amount"
            >
              <vue-autonumeric
                v-model="form.amount"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('amount') }"
                class="form-control"
                data-vv-as="Množstvo"
                name="amount"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('amount') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Dohodnutý regulačný príkon (kW)"
              label-for="regulationPower"
            >
              <vue-autonumeric
                v-model="form.regulationPower"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('regulationPower') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 4,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="Dohodnutý regulačný príkon"
                name="regulationPower"
              />
              <b-form-invalid-feedback>
                {{ errors.first('regulationPower') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Regulačný príkon podľa skut. odberu (kW)"
              label-for="regulationPowerReal"
            >
              <vue-autonumeric
                v-model="form.regulationPowerReal"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('regulationPowerReal') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 4,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="Regulačný príkon podľa skut. odberu"
                name="regulationPowerReal"
              />
              <b-form-invalid-feedback>
                {{ errors.first('regulationPowerReal') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Celková cena (€ bez dph)"
              label-for="totalPrice"
            >
              <vue-autonumeric
                v-model="form.totalPrice"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('totalPrice') }"
                class="form-control"
                data-vv-as="Celková cena"
                name="totalPrice"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('totalPrice') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Priem. jedn. cena (€ bez dph/kWh)"
              label-for="priceUnit"
            >
              <vue-autonumeric
                v-model="sumPriceUnit"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('priceUnit') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 4,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="Priem. jedn. cena"
                disabled
                name="priceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('priceUnit') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import SingleDate from '@/components/inputs/SingleDate'
import Modal from '@/components/Modal'
import { mapState } from 'vuex'

export default {
  components: {
    SingleDate,
    Modal,
  },
  data() {
    return {
      loading: false,
      form: {},
      field: [],
      month: null,
      year: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
    measureTypeFormat() {
      return 'MM/YYYY'
    },
    sumPriceUnit: {
      get() {
        let total = this.form.totalPrice
        return total ? this.form.totalPrice / this.form.amount : 0
      },
      set(val) {
        this.form.priceUnit = val
      },
    },
  },
  methods: {
    fetchData() {
      this.form.energetics_id = parseInt(this.$route.params.energetics_id)
      if (this.$parent.id) {
        this.loading = true
        this.$api
          .get(`reports/${this.$parent.id}/consumer/get_form`)
          .then((res) => {
            this.form = res.data.data
            this.loading = false
          })
      }
    },
  },
}
</script>
